import React, { useLayoutEffect } from "react";
import PropTypes from "prop-types";
import Immutable from "immutable";
import { connect } from "react-redux";
import { ENDPOINT_PATH } from "../../../../config/paths";
import { clearEndpoint, getEndpoint } from "../../../../actions";
import { breadcrumbsPropTypes, matchPropTypes } from "../../../common/resource/proptypes/CommonPropTypes";
import Content from "../../../layout/Content";
import Loader from "../../../common/Loader";
import NoDataResource from "../../../common/resource/NoDataResource";
import EndpointBasicInformationResource from "./resources/EndpointBasicInformationResource";
import EndpointToolbar from "./EndpointToolbar";
import InternalResource from '../../../common/resource/InternalResource';

export const Endpoint = ({
    breadcrumbs,
  dispatchGetEndpoint,
  dispatchClearEndpoint,
  match: {
    params: { id: endpointId },
  },
  loading,
  endpoint,
}) => {
  useLayoutEffect(() => {
    dispatchGetEndpoint({ endpointId });

    return () => dispatchClearEndpoint();
  }, []);

  let content;
  let toolbar;

  if (loading) content = <Loader />;
  else if (endpoint.isEmpty())
    content = <NoDataResource returnPage={ENDPOINT_PATH} />;
  else {
    const endpointJson = endpoint.toJS();

    content = (
      <>
        <h3>Información Básica</h3>
        <EndpointBasicInformationResource {...endpointJson} />
        <InternalResource id={endpointJson.id}
          createDate={endpointJson.createDate}
          lastUpdate={endpointJson.lastUpdate}/>
      </>
    );

    toolbar = <EndpointToolbar endpointId={endpointJson.id} />;
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      toolbar={toolbar}
      title="Punto de Acceso"
      content={content}
    />
  );
};

Endpoint.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearEndpoint: PropTypes.func.isRequired,
  dispatchGetEndpoint: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  endpoint: PropTypes.instanceOf(Immutable.Map).isRequired,
};

Endpoint.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearEndpoint: clearEndpoint,
  dispatchGetEndpoint: getEndpoint
};

const mapStateToProps = ({ SecurityUnit }) => ({
  breadcrumbs: [
    ...SecurityUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Puntos de Acceso',
      href: ENDPOINT_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  endpoint: SecurityUnit.Endpoint.getIn(['current', 'content']),
  loading: !SecurityUnit.Endpoint.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

export default connect(mapStateToProps, mapDispatchToProps)(Endpoint);